import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useThirdPartyUsers } from '../../hooks/useThirdPartyUser'
import ParentTable from './parentChild/ParentTable'
import { toast } from 'react-toastify'
import { t } from 'i18next'
import { useQueryClient } from 'react-query'
import ChildTable from './parentChild/ChildTable'
import { Box, Button, Divider, Grid, Stack, TextField, Typography } from '@mui/material'
import { Icon } from '@iconify/react'
import { setShareDataModal } from '../../store/reducers/modal.reducer'
import { useDispatch } from 'react-redux'
import ShareDataModal from '../modals/ShareDataModal'
import { debounce } from 'lodash'

function ThirdPartyUsers() {

    const [openDeleteParent, setOpenDeleteParent] = useState(false)
    const [openDeleteChild, setOpenDeleteChild] = useState(false)

    const [childPage, setChildPage] = useState(0)
    const [parentPage, setParentPage] = useState(0)

    const [parentSearch, setParentSearch] = useState("")
    const [childSearch, setchildSearch] = useState("")

    const userId = useSelector<RootState>((state) => state.user.user?.['@id']) as string | undefined
    const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
    const query = useQueryClient()
    const dispatch = useDispatch()
    const { parents, childs, isLoadingParents, isLoadingChilds, deleteParentChildMutation, countParents, countChildren, refetchParents, refetchChilds } = useThirdPartyUsers({
        enableQuery: !isUserLoading, userId,
        childOptions: `page=${childPage + 1}`.concat(childSearch ? `&q=${childSearch}` : ""),
        parentOptions: `page=${parentPage + 1}`.concat(parentSearch ? `&q=${parentSearch}` : ""),
    })

    const handleParentDelete = (id: number) => {
        deleteParentChildMutation.mutateAsync(id)
            .then(() => {
                query.refetchQueries(['users_parents'])
                query.refetchQueries(['users_childs'])

                setOpenDeleteParent(false)
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
            })
    }

    const handleChildDelete = (id: number) => {
        deleteParentChildMutation.mutateAsync(id)
            .then(() => {
                query.refetchQueries(['users_childs'])
                query.refetchQueries(['users_parents'])
                setOpenDeleteChild(false)
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
            })
    }

    const openShareModal = () => {
        dispatch(setShareDataModal(true))
    }

    const handleParentSearch = debounce((value: string) => {
        setParentSearch(value)
    }, 400)
    const handleChildSearch = debounce((value: string) => {
        setchildSearch(value)
    }, 400)
    return (
        <Stack spacing={2}>
            <Grid container spacing={2}  >
                <Grid item md={5} xs={12}>
                    <Typography variant='h6' color={'white'} >{t('thirdPartyApi:usersHasAccessToYourData')}</Typography>
                </Grid>
                <Grid item md={2} xs={12}>
                    <TextField label={t('equimetre:search')} fullWidth variant='outlined' size='small' onChange={e => handleParentSearch(e.target.value)} ></TextField>
                </Grid>
                <Grid item md={5} xs={12} >
                    <Button onClick={openShareModal} sx={{ float: 'right' }} variant='contained' startIcon={<Icon icon='streamline:share-link'></Icon>}>{t('thirdPartyApi:share')}</Button>
                </Grid>
            </Grid>
            <ParentTable
                data={parents}
                isLoading={isLoadingParents}
                isDeleting={deleteParentChildMutation.isLoading}
                onDelete={handleParentDelete}
                open={openDeleteParent}
                handleClose={(value) => setOpenDeleteParent(value)}
                countParents={countParents}
                page={parentPage}
                onPageChange={value => setParentPage(value)}
            />
            <Divider />
            <Grid container spacing={2}  >
                <Grid item md={5} xs={12}>
                    <Typography variant='h6' color={'white'} mb={2}>{t('thirdPartyApi:usersHasAccessToTheirData')}</Typography>
                </Grid>
                <Grid item md={2} xs={12}>
                    <TextField fullWidth label={t('equimetre:search')} variant='outlined' size='small' onChange={e => handleChildSearch(e.target.value)} ></TextField>
                </Grid>
                <Grid item md={5} xs={12}>
                </Grid>
            </Grid>
            <ChildTable
                data={childs}
                isLoading={isLoadingChilds}
                isDeleting={deleteParentChildMutation.isLoading}
                onDelete={handleChildDelete}
                open={openDeleteChild}
                handleClose={(value) => setOpenDeleteChild(value)}
                countChildren={countChildren}
                page={childPage}
                onPageChange={value => setChildPage(value)}
            />

            <ShareDataModal
                onSuccess={() => {
                    refetchChilds()
                    refetchParents()
                }}
            />
        </Stack>
    )
}

export default ThirdPartyUsers